import { createContext, useContext } from "react";

export interface DivisionNavContextValue {
  eventId: string;
  division: string;
  versionId: string | null;
  counts: any;
  event: any;
  /** Re-read the sidebar counts after a save — they are never cached. */
  refreshCounts: () => void;
}

export const DivisionNavContext = createContext<DivisionNavContextValue | null>(null);

export function useDivisionContext(): DivisionNavContextValue {
  const ctx = useContext(DivisionNavContext);
  if (!ctx) throw new Error("useDivisionContext must be used inside the Divisions layout");
  return ctx;
}
